<!-- 城市匹配器组件 -->
<template>
    <div class="where-belong">
        <h2 class="where-belong__title">{{ sectionTitle }}</h2>
        <p class="where-belong__subtitle">{{ sectionSubtitle }}</p>

        <div class="where-belong__container">
            <!-- 维度选择器 -->
            <div class="where-belong__selectors">
                <!-- Vibe -->
                <div class="where-belong__section">
                    <h3 class="where-belong__section-title">Vibe</h3>
                    <div class="where-belong__options">
                        <button v-for="option in vibeOptions" :key="option" class="where-belong__option"
                            :class="{ 'where-belong__option--active': selectedVibe === option }"
                            @click="selectedVibe = option">
                            {{ option }}
                        </button>
                    </div>
                </div>

                <!-- Climate -->
                <div class="where-belong__section">
                    <h3 class="where-belong__section-title">Climate</h3>
                    <div class="where-belong__options">
                        <button v-for="option in climateOptions" :key="option" class="where-belong__option"
                            :class="{ 'where-belong__option--active': selectedClimate === option }"
                            @click="selectedClimate = option">
                            {{ option }}
                        </button>
                    </div>
                </div>

                <!-- Budget（home_5 在筛选项上方：标题之前，表格 FZ5eG2） -->
                <div class="where-belong__section">
                    <div v-if="isMobile && budgetTopAd" class="where-belong__ad-block where-belong__ad-block--budget">
                        <AdComponent class="ad-width-100" :ads="budgetTopAd" :showDebug="showAdDebug" :forceDebug="true"
                            debugLabel="home_5" debugPosition="Budget 筛选项上方（仅移动端）" />
                    </div>
                    <h3 class="where-belong__section-title">Budget</h3>
                    <div class="where-belong__options">
                        <button v-for="option in budgetOptions" :key="option" class="where-belong__option"
                            :class="{ 'where-belong__option--active': selectedBudget === option }"
                            @click="selectedBudget = option">
                            {{ option }}
                        </button>
                    </div>
                </div>

                <button class="where-belong__cta" @click="getRecommendations">
                    <span><img src="@/assets/recon-star.svg" alt=""></span> See Recommendations
                </button>
            </div>

            <!-- 推荐城市 -->
            <div class="where-belong__result">
                <div class="where-belong__city-card">
                    <div class="where-belong__city-image" :style="{ backgroundImage: 'url(' + cityImage + ')' }"></div>
                    <div class="where-belong__city-overlay">
                        <div class="where-belong__city-name">{{ selectedCity.name }}</div>
                        <a class="where-belong__city-action" :href="getCityUrl(selectedCity.slug)">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"
                                fill="none">
                                <path
                                    d="M15.7418 8.65754L8.86935 15.7438C8.51764 16.094 7.95716 16.0839 7.61748 15.7213C7.28613 15.3675 7.28613 14.8067 7.61748 14.4529L12.9791 8.9241H0.885342C0.396381 8.9241 0 8.51539 0 8.01122C0 7.50705 0.396381 7.09834 0.885342 7.09834H12.9791L7.61748 1.56949C7.26578 1.21924 7.25604 0.641323 7.59574 0.278684C7.93543 -0.0839541 8.49591 -0.0939924 8.84761 0.256264C8.85498 0.263607 8.86223 0.271082 8.86935 0.278685L15.7418 7.36536C15.7834 7.40806 15.8206 7.45501 15.8529 7.50548C15.8666 7.52694 15.8764 7.55113 15.8883 7.57304C15.9049 7.60251 15.9197 7.63299 15.9326 7.66433C15.9435 7.69417 15.9527 7.72465 15.9601 7.75561C15.9676 7.78209 15.9778 7.80765 15.9831 7.83503C16.0056 7.95303 16.0056 8.07443 15.9831 8.19243C15.9778 8.21981 15.9676 8.24492 15.9601 8.27139C15.9527 8.30235 15.9435 8.33283 15.9326 8.36268C15.9197 8.39401 15.9049 8.4245 15.8883 8.45397C15.8764 8.47633 15.8667 8.49961 15.8529 8.52152C15.8202 8.57039 15.783 8.61594 15.7418 8.65754Z"
                                    fill="black" />
                            </svg>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import AdComponent from '@/pages/components/AdComponent.vue'
import adMixin from '@/mixin/adMixin.js'

export default {
    name: 'HomeWhereYouBelong',
    components: {
        AdComponent
    },
    mixins: [adMixin],
    props: {
        budgetTopAd: {
            type: Object,
            default: () => ({})
        },
        showAdDebug: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            vibeOptions: [],
            climateOptions: [],
            budgetOptions: [],

            selectedVibe: '',
            selectedClimate: '',
            selectedBudget: '',
            selectedCity: {}
        }
    },
    computed: {
        ...mapGetters(['livableCityData', 'deviceType']),
        sectionTitle() {
            return 'Where Do You Belong?'
        },
        sectionSubtitle() {
            return 'Three simple steps to find where you might belong.'
        },
        isMobile() {
            return this.deviceType === 'mobile'
        },
        cityImage() {
            return this.selectedCity.image || ''
        }
    },
    created() {
        const options = this.livableCityData.homeMatcherOptions || {}
        this.vibeOptions = options.vibe || []
        this.climateOptions = options.climate || []
        this.budgetOptions = options.budget || []
        this.selectedVibe = this.vibeOptions[0] || ''
        this.selectedClimate = this.climateOptions[0] || ''
        this.selectedBudget = this.budgetOptions[0] || ''
        this.selectedCity = this.pickCity(false)
    },
    methods: {
        getCityUrl(slug) {
            const path = `/${slug || 'tokyo'}`
            if (this.$route.params.channel) {
                return `/${this.$route.params.channel}${path}`
            }
            return path
        },
        pickCity(useRandom = true) {
            const source = this.livableCityData.cities || []
            const list = source.filter((city) => {
                const fit = city.fit || {}
                return (
                    fit.vibe === this.selectedVibe &&
                    fit.climate === this.selectedClimate &&
                    fit.budget === this.selectedBudget
                )
            })
            const target = list.length ? list : source
            if (!target.length) {
                return {}
            }
            if (!useRandom) {
                return [...target].sort((a, b) => b.score - a.score)[0]
            }
            return target[Math.floor(Math.random() * target.length)]
        },
        getRecommendations() {
            this.selectedCity = this.pickCity(true)
        }
    }
}
</script>

<style lang="scss" scoped>
@import '~@/css/variables.scss';

.where-belong {
    width: 100%;
    box-sizing: border-box;
    // background: transparent; // Assuming transparent on main cream bg

    &__ad-block {
        margin: 0 auto rem(16);
        width: 100%;
    }

    &__ad-block--budget {
        margin-bottom: rem(20);
    }

    &__title {
        text-align: center;
        font-family: $font-family-serif;
        font-size: rem(28);
        font-weight: 700;
        color: #000;
        line-height: rem(36);
        margin: 0 0 rem(12) 0;
        white-space: normal;
        overflow-wrap: anywhere;
    }

    &__subtitle {
        text-align: center;
        font-family: $font-family-serif;
        font-size: rem(16);
        font-weight: 300;
        color: #000;
        line-height: rem(24);
        margin: 0 0 rem(40) 0;
    }

    &__container {
        width: 100%;
        max-width: rem(1200);
        margin: 0 auto;
        display: flex;
        gap: rem(40);
        flex-direction: column; // Default Mobile
        min-width: 0;
    }

    &__selectors {
        flex: 1;
        display: flex;
        flex-direction: column;
        gap: rem(32);
    }

    &__section {
        display: flex;
        flex-direction: column;
        gap: rem(24);

        &-title {
            font-family: $font-family-serif;
            font-weight: 700;
            font-style: italic;
            font-size: rem(20);
            color: #000;
            margin: 0;
        }
    }

    &__options {
        display: flex;
        flex-wrap: wrap;
        gap: rem(16);
    }

    &__option {
        padding: 0 rem(16);
        height: rem(40);
        display: flex;
        align-items: center;
        justify-content: center;
        border: 1px solid $color-primary; // Default border yellow
        border-radius: rem(100);
        background: transparent;
        font-family: $font-family-serif;
        font-size: rem(16);
        font-weight: 400; // Regular
        color: #000;
        cursor: pointer;
        transition: all 0.3s;

        &:hover {
            border-width: 2px;
        }

        &--active {
            background: $color-primary; // #fecd45
            border-color: $color-primary;
            font-weight: 500; // Medium
        }
    }

    &__cta {
        width: 100%;
        margin-top: rem(24);
        height: rem(60);
        background: #000;
        color: $color-primary; // Yellow text
        border: none;
        border-radius: rem(100);
        font-family: $font-family-serif;
        font-size: rem(22);
        font-weight: 700;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: rem(12);
        transition: transform 0.2s;

        &:hover {
            transform: scale(1.02);
            opacity: 0.9;
        }

        span {
            font-size: rem(24); // Star icon size
        }
    }

    &__result {
        display: flex;
        justify-content: center;
        width: 100%;
    }

    &__city-card {
        width: 100%;
        max-width: rem(343); // Mobile width
        height: rem(343);
        border-radius: rem(24);
        overflow: hidden;
        background: #000;
        position: relative;
        box-shadow: 0 rem(4) rem(16) rgba(0, 0, 0, 0.1);
        transition: transform 0.2s ease;
    }

    &__city-image {
        width: 100%;
        height: 100%;
        background-size: cover;
        background-position: center;
        position: absolute;
        inset: 0;
    }

    &__city-overlay {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        padding: rem(24);
        background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, #000 80%);
        display: flex;
        align-items: center;
        justify-content: space-between;
        z-index: 2;
    }

    &__city-action {
        width: rem(40);
        height: rem(40);
        border-radius: 50%;
        background: $color-primary;
        border: none;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        transition: transform 0.2s;
        flex-shrink: 0;

        &:hover {
            transform: scale(1.1);
        }
    }

    &__city-name {
        font-family: $font-family-serif;
        font-size: rem(24);
        font-weight: 700;
        color: #fff;
        margin: 0;
        text-shadow: 0 rem(2) rem(4) rgba(0, 0, 0, 0.16);
    }
}

// PC端样式
.detect_deviece_pc,
.detect_deviece_desktop {
    .where-belong {
        padding: rem(100) rem(180);

        &__title {
            font-size: rem(28);
        }

        &__subtitle {
            font-size: rem(16);
        }

        &__container {
            flex-direction: row; // Split layout
            align-items: flex-start;
            justify-content: space-between;
            max-width: rem(1080); // Ensure content max-width matches Figma
        }

        &__selectors {
            flex: 1 1 0;
            min-width: 0;
            max-width: calc((100% - #{rem(40)}) / 2);
        }

        &__result {
            flex: 1 1 0;
            min-width: 0;
            max-width: calc((100% - #{rem(40)}) / 2);
            justify-content: flex-end;
        }

        &__city-card {
            width: 100%;
            max-width: rem(528);
            height: rem(528); // Square matching width

            &:hover {
                transform: translateY(rem(-4));
            }
        }

        &__option {
            cursor: pointer;
        }

        &__cta {
            width: rem(360);
            margin-top: auto; // Push button to bottom to match Figma layout
        }
    }
}

// Mobile端样式
.detect_deviece_mobile {
    .where-belong {
        padding: rem(60) rem(16);

        &__title {
            font-size: rem(28);
            line-height: rem(36);
        }

        &__subtitle {
            font-size: rem(16);
            line-height: rem(24);
        }

        &__result {
            margin-top: rem(40);
        }
    }
}
</style>
